<template>
  <modal :title="`Delete ${this.type}`" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      Are you sure you want to delete this <span class="text-lowercase">{{ type }}</span>?
    </h2>
    <template v-slot:actions>
      <async-btn label="Delete" color="negative" :task="task" @click="remove" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Report, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { deleteAll } from './report';
import { isAlbum } from '.';

interface Data {
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    report: {
      type: Object as () => Report,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    type(): string {
      return isAlbum(this.report.type) ? 'Album' : 'Report';
    },
  },
  methods: {
    remove() {
      this.task = deleteAll([this.report.id]);
      this.task.then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify(`${this.type} deleted.`);
      });
    },
  },
});
</script>
